import React from 'react';

function Home() {
  return (
    <div style={{ padding: '20px' }}>
      <h1>Home Page</h1>
      <p>Welcome to Sidelia Exim.</p>
    </div>
  );
}

export default Home;